var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-section",
    {
      staticClass: "flyover__wrapper",
      attrs: {
        bold: "",
        border: "none",
        size: 6,
        title: _vm.selectedRowInfo.name,
      },
      scopedSlots: _vm._u([
        {
          key: "mds-section-actions",
          fn: function () {
            return [
              _c("mds-button", {
                attrs: { variation: "icon-only", icon: "remove" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("closeFlyover")
                  },
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("flyover-tabs", {
        attrs: { tabs: _vm.tabs },
        on: { tabClick: _vm.changeActiveTab },
      }),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }